import { z } from 'zod';
import { DATE_STRING_REGEX } from '../../utils/constants';
export const EditUserWorkExperienceSchema = z.object({
    location: z.string(),
    id: z.number().optional(),
    position: z.string().optional(),
    companyName: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    current: z.boolean().optional().default(false).nullable(),
    endedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    startedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    isVolunteering: z.boolean().default(false).optional().nullable()
});
//# sourceMappingURL=editUserWorkExperienceSchema.js.map